import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer + visitor correlation headers on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bdu_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  try {
    const vid = localStorage.getItem("bdu_visitor_id");
    const sid = localStorage.getItem("bdu_session_id");
    config.headers = config.headers || {};
    if (vid) config.headers["X-BDU-Visitor"] = vid;
    if (sid) config.headers["X-BDU-Session"] = sid;
  } catch (_e) {
    /* localStorage disabled — ignore */
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
